import { useEffect, useState } from 'react';
import { NormalizedOverwhelmedOverlayData, OverwhelmedOverlayState } from './types';
import useFetchAPI from '@ids/hooks/useFetchAPI';
import { OverwhelmedOverlayResponse } from '@ids/types/now-api';
import { Maybe } from '@ids/types/utility';
import { useFeatureToggle } from '@ids/appshell';
import { OverwhelmedOverlayDataModel } from '@ids/types/contentful';

const normalizeOverwhelmedOverlayData = (
    data: Maybe<OverwhelmedOverlayResponse>
): Maybe<NormalizedOverwhelmedOverlayData> => {
    if (!data || !data?.data?.length) {
        return null;
    }

    const overwhelmedOverlayData = data?.data[0];

    return {
        emailForm: overwhelmedOverlayData.emailForm,
        thankYouNote: {
            title: overwhelmedOverlayData.thankYouTitle,
            description: overwhelmedOverlayData.thankYouParagraph,
            timer: overwhelmedOverlayData.thankYouTimer,
        },
    };
};

const useOverwhelmedOverlayData = (): OverwhelmedOverlayState['formData'] => {
    const { p100IdsOverwhelmedOverlay } = useFeatureToggle();
    const { makeRequest } = useFetchAPI();

    const [overwhelmedOverlayData, setOverwhelmedOverlayData] = useState<Maybe<NormalizedOverwhelmedOverlayData>>(null);

    useEffect(() => {
        if (p100IdsOverwhelmedOverlay) {
            const fetchOverwhelmedOverlayData = async () => {
                const overwhelmedOverlayResponse = await makeRequest<OverwhelmedOverlayDataModel[]>(
                    'web/v1/content/entries/overwhelmedOverlay'
                );

                setOverwhelmedOverlayData(normalizeOverwhelmedOverlayData(overwhelmedOverlayResponse));
            };

            fetchOverwhelmedOverlayData();
        }
    }, [makeRequest, p100IdsOverwhelmedOverlay]);

    return overwhelmedOverlayData;
};

export default useOverwhelmedOverlayData;
